<div class="warehouse-group-filter">
  <div>
    <label>Warehouse Group</label>
    <ng-select
      bindValue="id"
      bindLabel="label"
      [clearable]="false"
      [items]="(warehouseGroups$ | async) || []"
      [trackByFn]="trackWarehouseGroupByFn"
      [loading]="(warehouseGroupLoading$ | async) || false"
      (change)="onWarehouseGroupChange()"
      [(ngModel)]="value"
    >
    </ng-select>
  </div>
</div>
